<template>
  <div class="content">
    <video-player
      ref="videoPlayer"
      class="video-player vjs-custom-skin"
      :playsinline="true"
      :options="playerOptions"
      @timeupdate="handleTimeUpdate"
      @play="handleAutoPlay"
      @pause="handleAutoPause"
      @ended="handleEnd"
    />
    <img src="@/assets/img/close.png" class="close_img" @click="closeVideo">
    <div v-if="showTime" class="showTime">学习进度 {{ getTime }}
      <span class="play_btn" @click="goTime">继续播放</span>
      <i class="el-icon-close" style="cursor: pointer;margin-left: 13px;" @click="closeTips" />
    </div>
    <Tips :tip-parmas="tipParmas" @confirm="tipsClose" @cancel="tipsClose" />
  </div>
</template>

<script>

import { videoPlayer } from 'vue-video-player';
import { studyVideo } from '@/http/index'
import 'video.js/dist/video-js.css'; // 引入 video.js 样式文件
import 'vue-video-player/src/custom-theme.css'; // 引入 vue-video-player 样式文件
import Tips from './child/tips.vue'
import { turnFullScreen } from '@/utils/exam'

export default {
  components: { videoPlayer, Tips },
  data() {
    return {
      tipParmas: {
        tipsVisible: false,
        code: 0
      },
      player: null,
      playerOptions: {},
      videoSrc: '',
      videoId: '',
      videoType: '',
      maxDragTime: 0, // 最大拖动时间，单位为秒
      isDragging: false,
      currentTime: 0,
      lookTime: 0,
      isAutoPlay: false,
      timer: null,
      showTime: false,
      videoList: [],
      videoActive: 0,
      firstShow: true,
      isFullscreen: false,
      showFull: true,
      videoTime: 0,
      dragTime: 0
    };
  },
  computed: {
    getTime() {
      const hours = Math.floor(this.maxDragTime / 3600);
      const minutes = Math.floor((this.maxDragTime % 3600) / 60);
      const seconds = this.maxDragTime % 60;
      return `${this.padZero(hours)}:${this.padZero(minutes)}:${this.padZero(seconds)}`;
    }
  },
  watch: {
    'videoSrc': {
      handler(newSrc, oldSrc) {
        if (newSrc !== oldSrc && oldSrc) {
          // 等待新视频加载完成后，设置播放时长
          this.$nextTick(() => {
            this.$refs.videoPlayer.player.currentTime(this.currentTime);
            // 播放新视频
            this.$refs.videoPlayer.player.play()
            return
          });
        }
      },
      deep: true
    }
  },
  mounted() {
    this.videoList = JSON.parse(this.$route.query.data).src
    this.videoSrc = this.videoList.find(item => item.name == '高清') ? this.videoList.find(item => item.name == '高清').PlayURL : this.videoList[0].PlayURL;
    this.videoId = JSON.parse(this.$route.query.data).id;
    this.videoType = JSON.parse(this.$route.query.data).type;
    this.doubleSpeed = JSON.parse(this.$route.query.data).doubleSpeed ? JSON.parse(this.$route.query.data).doubleSpeed : '';
    this.maxDragTime = JSON.parse(this.$route.query.data).viewingDuration ? JSON.parse(this.$route.query.data).viewingDuration : '';
    this.videoTime = JSON.parse(this.$route.query.data).duration ? JSON.parse(this.$route.query.data).duration : '';
    this.showTime = !!(this.maxDragTime && this.videoTime && this.videoTime > this.maxDragTime);
    this.playerOptions = {
      // playbackRates: this.doubleSpeed == 1 ? [1.0, 1.2, 1.5, 2.0] : [], // 可选的播放速度
      autoplay: true, // 如果为true,浏览器准备好时开始回放。
      muted: false, // 默认情况下将会消除任何音频。
      loop: false, // 是否视频一结束就重新开始。
      preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
      language: 'zh-CN',
      aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
      fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
      sources: [{
        type: "video/mp4", // 类型
        src: this.videoSrc // url地址
      }],
      poster: '', // 封面地址
      notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
      controlBar: {
        timeDivider: true, // 当前时间和持续时间的分隔符
        durationDisplay: true, // 显示持续时间
        remainingTimeDisplay: false, // 是否显示剩余时间功能
        fullscreenToggle: false // 是否显示全屏按钮
      }
    }
    var that = this;
    window.onblur = function() {
      that.pageHidden();
    };
    window.onfocus = function() {
      that.pageShow();
    };
    // 监听是否全屏
    window.addEventListener("fullscreenchange", this.handleFullscreenChange);
    window.addEventListener("webkitfullscreenchange", this.handleFullscreenChange);
    // 监听页面可见性
    window.addEventListener("visibilitychange", this.pageHidden);
    setTimeout(() => {
      this.$nextTick(() => {
        document.addEventListener('mouseup', this.handleDragEnd, true);
        this.$refs.videoPlayer.$el.querySelector('.vjs-control-bar').addEventListener('mousedown', this.handleDragStart, true);
        const controlBar = this.$refs.videoPlayer.$el.querySelector('.vjs-control-bar');
        const select = document.createElement('select');
        select.className = 'vjs-qxd-control';
        // 查找是否存在高清选项
        const hdQuality = this.videoList.find(quality => quality.name === '高清');
        var defaultQuality = null; // 默认选项
        if (hdQuality) {
          defaultQuality = hdQuality.PlayURL;
        } else if (this.videoList.length > 0) {
          defaultQuality = this.videoList[0].PlayURL; // 默认选择第一个选项
        }
        this.videoList.forEach(quality => {
          const option = document.createElement('option');
          option.value = quality.PlayURL;
          option.textContent = quality.name;
          option.className = 'option'
          if (quality.PlayURL === defaultQuality) {
            option.selected = true; // 设置默认选项
          }
          select.appendChild(option);
        });

        select.addEventListener('change', this.changeQuality);
        controlBar.appendChild(select);
        if (this.doubleSpeed == 1) {
          const select2 = document.createElement('select');
          select2.className = 'vjs-bs-control';
          const playbackRates = [{
            name: '×1.0',
            value: 1
          }, {
            name: '×1.2',
            value: 1.2
          }, {
            name: '×1.5',
            value: 1.5
          }, {
            name: '×2.0',
            value: 2
          }]
          playbackRates.forEach(quality => {
            const option = document.createElement('option');
            option.value = quality.value;
            option.textContent = quality.name;
            option.className = 'option'
            select2.appendChild(option);
          });

          select2.addEventListener('change', this.changeRates);
          controlBar.appendChild(select2);
        }
      })
    }, 2000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    document.removeEventListener('mouseup', this.handleDragEnd);
    this.$refs.videoPlayer.$el.querySelector('.vjs-control-bar').removeEventListener('mousedown', this.handleDragStart);
    this.$refs.videoPlayer.$el.removeEventListener('play', this.handleAutoPlay);
    this.$refs.videoPlayer.$el.removeEventListener('pause', this.handleAutoPause);
    window.removeEventListener('fullscreenchange', this.handleFullscreenChange)
    window.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange)
    window.removeEventListener('visibilitychange', this.pageHidden)
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  },
  methods: {
    closeTips() {
      this.showTime = false
    },
    changeRates(e) {
      this.$refs.videoPlayer.player.playbackRate(e.target.value);
    },
    handleFullscreenChange() {
      this.isFullscreen = document.fullscreenElement !== null || document.webkitIsFullScreen;
      if (!this.isFullscreen && this.showFull) {
        this.closeVideo();
      }
    },
    getNowTime() {
      var myDate = new Date();
      var year = myDate.getFullYear(); // 获取当前年
      var mon = myDate.getMonth() + 1 < 10 ? "0" + (myDate.getMonth() + 1) : myDate.getMonth() + 1; // 获取当前月
      var date = myDate.getDate() < 10 ? "0" + myDate.getDate() : myDate.getDate(); // 获取当前日
      var hour = myDate.getHours() < 10 ? "0" + myDate.getHours() : myDate.getHours();// 获取当前时
      var minute = myDate.getMinutes() < 10 ? "0" + myDate.getMinutes() : myDate.getMinutes();// 获取当前分
      var seconds = myDate.getSeconds() < 10 ? "0" + myDate.getSeconds() : myDate.getSeconds();// 获取当前分
      return year + "-" + mon + "-" + date + " " + hour + ":" + minute + ":" + seconds;
    },
    changeQuality(e) {
      this.videoSrc = e.target.value
    },
    closeVideo() {
      this.submitVideo(1)
    },
    goTime() {
      this.currentTime = this.maxDragTime
      this.$refs.videoPlayer.player.currentTime(this.maxDragTime);
      this.showTime = false;
    },
    handleDragStart() {
      this.isDragging = true;
    },
    handleDragEnd() {
      this.isDragging = false;
    },
    handleAutoPlay() {
      this.isAutoPlay = true;
      var that = this;
      if (this.firstShow) {
        localStorage.setItem('lookVideoTime', this.getNowTime())
        this.firstShow = false;
      }
      this.timer = setInterval(async() => {
        that.lookTime++;
        localStorage.setItem('lookVideoInfo', JSON.stringify({
          video_id: this.videoId,
          viewing_duration: this.currentTime,
          accumulated_viewing_duration: this.lookTime,
          hospital_id: localStorage.getItem('hospital_id'),
          token: localStorage.getItem('token'),
          secret: localStorage.getItem('secret')
        }))
        if (that.lookTime > 4) {
          that.showTime = false;
        }
        if (that.lookTime % 120 === 0) {
          localStorage.setItem('lookVideoTime', this.getNowTime())
          this.submitVideo()
        }
      }, 1000);
    },
    tipsClose() {
      clearInterval(this.timer)
      localStorage.removeItem('lookVideoTime')
      localStorage.removeItem('lookVideoInfo')
      this.$router.back(-1)
    },
    handleEnd() {
      this.submitVideo();
      this.$refs.videoPlayer.player.pause() // 暂停
      clearInterval(this.timer);
    },
    async submitVideo(type) {
      const res = await studyVideo({
        video_id: this.videoId,
        viewing_duration: this.currentTime,
        accumulated_viewing_duration: this.lookTime,
        hospital_id: localStorage.getItem('hospital_id'),
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret')
      })
      if (res.data.code) {
        this.tipParmas = {
          tipsVisible: true,
          code: res.data.code
        }
        this.$refs.videoPlayer.player.pause() // 暂停
        clearInterval(this.timer)
        localStorage.removeItem('lookVideoTime')
        localStorage.removeItem('lookVideoInfo')
      } else {
        this.lookTime = 0
        if (type == 1) {
          clearInterval(this.timer)
          localStorage.removeItem('lookVideoTime')
          localStorage.removeItem('lookVideoInfo')
          this.$router.back(-1)
        }
      }
    },
    handleAutoPause() {
      this.isAutoPlay = false;
      clearInterval(this.timer);
    },
    handleTimeUpdate(event) {
      if (this.isDragging) {
        return
      }
      const currentTime = Math.floor(event.cache_.currentTime);
      if (this.isAutoPlay) { // 播放中
        if (currentTime - this.currentTime == 1 || currentTime - this.currentTime == 0) {
          // 正常播放
          this.currentTime = currentTime
          if (currentTime > this.maxDragTime) {
            this.maxDragTime = this.currentTime
          }
        } else {
          // 播放器被拖动
          if (currentTime > this.maxDragTime) { // && !this.isDrag
            // 如果当前时间超过了最大拖动时间，则设置为最大时间
            this.$refs.videoPlayer.player.currentTime(this.maxDragTime);
            this.currentTime = this.maxDragTime
            this.$message({
              type: 'info',
              message: '只能在已观看的学习进度范围内拖动进度条',
              duration: 2000
            })
          } else {
            this.currentTime = currentTime
            if (currentTime > this.maxDragTime) {
              this.maxDragTime = this.currentTime
            }
          }
        }
      } else { // 暂停
        if (currentTime > this.maxDragTime) {
          this.$refs.videoPlayer.player.currentTime(this.maxDragTime);
          this.$message({
            type: 'info',
            message: '只能在已观看的学习进度范围内拖动进度条',
            duration: 2000
          })
        }
      }
    },
    // 离开页面
    pageHide() {
      this.$refs.videoPlayer.player.pause() // 暂停
      clearInterval(this.timer);
    },
    // 进入页面
    pageShow() {
      // this.$refs.videoPlayer.player.play() // 播放
    },
    // 页面被覆盖
    pageHidden() {
      this.$refs.videoPlayer.player.pause() // 暂停
      clearInterval(this.timer);
    },
    padZero(num) {
      return num < 10 ? `0${num}` : num;
    }

  }
};
</script>
<style>
.vjs-custom-skin > .video-js .vjs-control-bar .vjs-qxd-control{
    -webkit-box-ordinal-group: 6 !important;
    -ms-flex-order: 5 !important;
    order: 5 !important;
	  background: none !important;
    color: #fff !important;
    border: none !important;
	  box-shadow:none !important;
    font-size: 1rem !important;
}
.vjs-custom-skin > .video-js .vjs-control-bar .vjs-bs-control{
    -webkit-box-ordinal-group: 5 !important;
    -ms-flex-order: 4 !important;
    order: 4 !important;
	  background: none !important;
    color: #fff !important;
    border: none !important;
	  box-shadow:none !important;
    font-size: 1rem !important;
}
.vjs-custom-skin > .video-js .vjs-control-bar .vjs-qxd-control:focus ,.vjs-custom-skin > .video-js .vjs-control-bar .vjs-bs-control:focus{
    outline: none !important;
}
.vjs-custom-skin > .video-js .vjs-control-bar  .option{
	color: #A6A6A6 !important;
	width: 100px !important;
	height: 40px !important;
	box-shadow:none !important;
	border: none !important;
	background: rgba(0,0,0,0.7) !important;
}
.video-js.vjs-fluid:not(.vjs-audio-only-mode), .video-js.vjs-16-9:not(.vjs-audio-only-mode), .video-js.vjs-4-3:not(.vjs-audio-only-mode), .video-js.vjs-9-16:not(.vjs-audio-only-mode), .video-js.vjs-1-1:not(.vjs-audio-only-mode){
	width: 100%;
	height: 100%;
	padding: 0 !important;
}
.video-player,.vjs-custom-skin{
	width: 100%;
	height: 100%;
}
.vjs_video_458-dimensions.vjs-fluid{
	padding: 0 !important;
}
.video-js .vjs-big-play-button{
	width: 70px !important;
	height: 70px !important;
	line-height: 70px !important;
	border-radius: 50%;
}

.video-js:hover .vjs-big-play-button, .vjs-custom-skin > .video-js .vjs-big-play-button:focus, .vjs-custom-skin > .video-js .vjs-big-play-button:active{
	background-color: transparent !important;
}
/* 自定义控制条的样式 */
.custom-control-bar {
  display: flex;
  align-items: center;
}

.custom-control-bar button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 4px;
}
</style>
    <style scoped lang="scss">
    .content{
      position: absolute;
      width: 100%;
      height: 100vh;
    }
    .close_img{
      position: fixed;
      top: 4%;
      right: 2%;
      width: 40px;
      height: 40px;
    }
    .showTime{
      position: fixed;
      right: 5%;
      bottom: 5%;
      background: #000000;
      border-radius: 12px 12px 12px 12px;
      opacity: 0.7;
      border-radius: 6px;
      padding:14px 20px;
      font-size: 16px;
      color: #FFFFFF;
      .play_btn{
          color: #DD594A;
          cursor: pointer;
      }
    }
    .definition{
	width: 100px;
	height: 100%;
	position: fixed;
	right: 0;
	top: 0;
	background-color: rgba($color: #000000, $alpha: 0.8);
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	align-content: center;
	padding: 0 10px;
	.definition_item{
		width: 100%;
		border: 1px solid #fff;
		text-align: center;
		padding: 8px 12px;
		border-radius: 6px;
		box-sizing: border-box;
		color: #FFFFFF;
		margin-bottom: 10px;
		font-size: 14px;
		cursor: pointer;
	}
	.active{
		border: 1px solid #DD594A;
		color: #DD594A;
	}
  }
    </style>
